// extracted by mini-css-extract-plugin
module.exports = {"container":"PropertiesContainer_container__gKGSa","eventBanner":"PropertiesContainer_eventBanner__tR1wq","carousel":"PropertiesContainer_carousel__cXexk"};